function buildMenu (allowed) {
  if (allowed == null || allowed.includes('Metrc'))  {
    return [
    {
      title: 'METRC Workflows',
      icon: 'mdi-shield-edit-outline',
      items: [
        {
          icon: 'mdi-tune',
          title: "Preferences",
          path: '/MetrcPrefs'
        }
      ]
    }
  ] } else return []
}

export default buildMenu